<template>
	<div>
		<div v-if="loading">
			<div class="success--text text-h4 text-center">
				در حال دریافت اطلاعات...
			</div>
		</div>
		<div v-else>
			<div v-if="!items.length">
				<h3 class="text-center red--text">تاکنون طرف حسابی در سیستم ثبت نشده است</h3>
				<div class="text-center mt-5">
					<v-btn class="mx-auto" color="secondary" dark @click="add">
						<v-icon dark>
							mdi-plus-circle-outline
						</v-icon>
						افزودن طرف حساب
					</v-btn>
				</div>
			</div>
			<div v-else>
				<v-card v-for="(item, index) in items" :key="item.id+index" class="mb-3 pa-3" elevation="0" style="border: 1px solid #dca6e5">
					<v-row>
						<v-col cols="1">
							<v-checkbox color="secondary" @change="(val) => checkboxChanged(val, item)" label="" :disabled="item.id===emptyId" />
						</v-col>
						<v-col cols="11">
							<v-row class="ma-0 pa-0">
								<v-col cols="12" md="4" class="py-0 my-0">
									<v-text-field :disabled="!item.editMode" v-model="item.fullName" label="نام*" :error-messages="errorMessages" :rules="[(val) => !!val || 'نام طرف حساب را وارد کنید']" required />
								</v-col>
								<v-col cols="12" md="4" class="py-0 my-0">
									<v-text-field :disabled="!item.editMode" v-model="item.businessName" label="نام تجاری*" :error-messages="errorMessages" :rules="[(val) => !!val || 'نام تجازی را وارد کنید']" required />
								</v-col>
								<v-col cols="12" md="4" class="py-0 my-0">
									<v-text-field :disabled="!item.editMode" v-model="item.phone" label="شماره تماس" :error-messages="errorMessages" />
								</v-col>
								<v-col cols="12" md="5" class="py-0 my-0">
									<v-text-field :disabled="!item.editMode" v-model="item.address" label="آدرس" :error-messages="errorMessages" />
								</v-col>
								<v-col cols="12" md="5" class="py-0 my-0">
									<v-text-field :disabled="!item.editMode" v-model="item.bankInfo" label="شماره حساب" :error-messages="errorMessages" />
								</v-col>
								<v-col cols="2" class="my-0 py-0">
									<v-btn v-if="!item.editMode" @click="edit(item)" class="ms-2" small fab dark color="secondary" title="ویراش">
										<v-icon dark>
											mdi-square-edit-outline
										</v-icon>
									</v-btn>
									<v-btn v-if="!item.editMode" @click="remove(item, index)" class="ms-2" small fab dark color="pink" title="حذف">
										<v-icon dark>
											mdi-trash-can-outline
										</v-icon>
									</v-btn>
									<v-btn :loading="submitLoading" @click="save(item, index)" class="ms-2" title="ذخیره" v-if="item.editMode" color="success" fab small dark>
										<v-icon dark>
											mdi-check
										</v-icon>
									</v-btn>
									<v-btn class="ms-2" @click="cancel(item, index)" v-if="item.editMode" title="انصراف" color="grey" fab small dark>
										<v-icon dark>
											mdi-close
										</v-icon>
									</v-btn>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-card>
				<div class="text-center mt-5">
					<v-btn class="mx-auto" color="secondary" dark @click="add">
						<v-icon dark>
							mdi-plus-circle-outline
						</v-icon>
						تعریف طرف حساب جدید
					</v-btn>
				</div>
			</div>
		</div>
		<div class="d-flex align-center justify-center mt-3">
			<v-btn color="blue" dark :disabled="selectedItems.length === 0" v-if="items.length" @click="emitSelectedItems">
				انتخاب
			</v-btn>
		</div>
		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'

	export default {
		name: 'Contacts',
		props: {
			data: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				emptyId: emptyId,
				selectedItems: [],
				errorMessages: '',
				items: [],
				localData: {},
				submitLoading: false,
				loading: false
			}
		},
		computed: {

		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('admin/Contact/List', null)
					.then(
						response => {
							this.items = response.map(x => {
								x.editMode = false
								return x
							})
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.loading = false
					})
			},
			edit(item) {
				item.editMode = true
				item.original = JSON.parse(JSON.stringify(item))
			},
			save(item, index) {
				this.submitLoading = true
				var clone = { ...item }
				api.post('admin/Contact/' + (item.id === emptyId ? 'create' : 'edit'), clone)
					.then(response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						item.editMode = false
						if (item.id === emptyId) {
							this.items[index].id = response
						}
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.submitLoading = false })
			},
			cancel(item, index) {
				if (item.id == emptyId) {
					this.items.splice(index, 1)
					return
				}
				item.fullName = item.original?.fullName
				item.businessName = item.original?.businessName
				item.phone = item.original?.phone
				item.address = item.original?.address
				item.bankInfo = item.original?.bankInfo
				item.editMode = false
			},
			async remove(item, index) {
				if (!item) {
					return
				}

				if (item.id == emptyId) {
					this.items.splice(index, 1)
					return
				}

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/Contact/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.items.splice(index, 1)
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			add() {
				let newItem = {
					id: emptyId,
					fullName: '',
					businessName: '',
					phone: '',
					address: '',
					bankInfo: '',
					editMode: true,
				}
				this.items.push(newItem)
			},
			checkboxChanged(state, item) {
				let index = this.selectedItems.findIndex(x => x.id === item.id)
				if (!state && index > -1)
					this.selectedItems.splice(index, 1)
				if (state && index === -1) {
					var clone = { ...item }
					this.selectedItems.push(clone)
				}
			},
			emitSelectedItems() {
				if (!this.selectedItems.length) {
					toast.error('حداقل یک آیتم باید انتخاب شود.')
					return
				}
				let notSaved = this.selectedItems.find(x => x.id === emptyId)
				if (notSaved) {
					toast.error(`آیتم ${notSaved.title} ذخیره نشده است.`)
					return
				}
				this.$emit('select', this.selectedItems)
			}
		},
	}
</script>
<style>
</style>
